module.exports = __webpack_public_path__ + "img/icn_check_kutsu.ded89bda.png";